if (!$.cookie("mouseInPP")) {
	var c = $.cookie("mouseInPP", 1, {
		expires: 1
	});
	setTimeout(() => {
		$('#modalForm').modal('show');
	}, 7000);
}

$(function() {
	
	$(document).ready(function() {
		$.removeCookie("mouseleavePP");
	});

	$(document).on("mouseout", function(e) {
		// if (!$.cookie("mouseleavePP")) {
		// 	var o = $.cookie("mouseleavePP");
		// 	if ("input" != e.target.tagName.toLowerCase()) {
		// 		var t = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
		// 		if (!(e.clientX >= t - 50 || (e.clientY >= 50))) {
		// 			e.relatedTarget || e.toElement || void 0 === o && ($.cookie("mouseleavePP", 1, {
		// 				expires: 1
		// 			}), $("#modalForm").modal('show'));
		// 		}
		// 	}
		// }
	})
	console.log(123)

});